module.exports = __webpack_public_path__ + "img/myposition_ss_데니스 베르캄프.01bad9b9.png";